<div class="propero-home">
  <section id="home" class="ph-hero ph-hero--compact">
    <div class="ph-hero__blob ph-hero__blob--brand" aria-hidden="true"></div>
    <div class="ph-hero__blob ph-hero__blob--accent" aria-hidden="true"></div>
    <div class="ph-container ph-hero__content--centered">
      <div class="ph-hero__badge">
        <span class="ph-hero__badge-dot" aria-hidden="true"></span>
        {{ 'CALCULATORS.HERO_EYEBROW' | translate }}
      </div>
      <h1 class="ph-hero__title">{{ 'CALCULATORS.TITLE' | translate }}</h1>
      <p class="ph-hero__subtitle">{{ 'CALCULATORS.TITLE_DESCRIPTION_LONG' | translate }}</p>
    </div>
  </section>

  <section id="features" class="ph-section ph-section--muted">
    <div class="ph-container">
      <div class="ph-tools__grid">
        <a *ngFor="let calc of calculatorCards" [routerLink]="calc.route" class="ph-tool-card">
          <div class="ph-tool-card__icon"><i class="lni" [ngClass]="calc.icon"></i></div>
          <h2 class="ph-tool-card__title">{{ calc.titleKey | translate }}</h2>
          <p class="ph-tool-card__text">{{ calc.textKey | translate }}</p>
          <span class="ph-tool-card__cta">
            {{ 'CALCULATORS.COMPUTE' | translate }}
            <i class="lni lni-arrow-right" aria-hidden="true"></i>
          </span>
        </a>
      </div>
    </div>
  </section>

  <section id="contact" class="ph-section ph-section--contact">
    <div class="ph-container ph-contact__grid">
      <div class="ph-contact__info">
        <h2 class="ph-contact__title">{{ 'HOME.SECTION_CONTACTUS_HEADING' | translate }}</h2>
        <p class="ph-contact__lead">{{ 'HOME.SECTION_CONTACTUS_TEXT' | translate }}</p>
        <div class="ph-contact__channels">
          <div class="ph-contact__channel">
            <div class="ph-contact__channel-icon"><i class="lni lni-phone"></i></div>
            <div>
              <div class="ph-contact__channel-label">Telefon</div>
              <div class="ph-contact__channel-value">{{ 'COMPANY.CONTACT_MAIN_PHONE' | translate }}</div>
            </div>
          </div>
          <div class="ph-contact__channel">
            <div class="ph-contact__channel-icon"><i class="lni lni-envelope"></i></div>
            <div>
              <div class="ph-contact__channel-label">Email</div>
              <div class="ph-contact__channel-value">{{ 'COMPANY.CONTACT_MAIN_EMAIL' | translate }}</div>
            </div>
          </div>
        </div>
      </div>

      <form #contactForm="ngForm" (ngSubmit)="send()" class="ph-contact__form" novalidate>
        <div class="ph-field">
          <label for="calc-list-name">{{ 'HOME.NAME' | translate }}</label>
          <input id="calc-list-name" type="text" name="name" [(ngModel)]="contactItem.subject" required [placeholder]="'HOME.NAME' | translate" />
        </div>
        <div class="ph-field">
          <label for="calc-list-email">{{ 'HOME.EMAIL' | translate }}</label>
          <input id="calc-list-email" type="email" name="email" [(ngModel)]="contactItem.email" required email [placeholder]="'HOME.EMAIL' | translate" />
        </div>
        <div class="ph-field">
          <label for="calc-list-message">{{ 'HOME.MESSAGE' | translate }}</label>
          <textarea id="calc-list-message" name="message" rows="4" [(ngModel)]="contactItem.content" required [placeholder]="'HOME.MESSAGE' | translate"></textarea>
        </div>
        <button type="submit" class="ph-btn ph-btn--brand ph-btn--block ph-btn--lg" [disabled]="contactForm.invalid || isLoading">
          <span *ngIf="!isLoading">{{ 'HOME.SEND' | translate }}</span>
          <span *ngIf="isLoading">{{ 'HOME.SENDING' | translate }}</span>
        </button>
        <p *ngIf="contactSuccess" class="ph-contact__success">Mesaj trimis! Te contactăm în curând.</p>
      </form>
    </div>
  </section>
</div>
